import * as React from 'react';
import { SVGProps } from 'react';

const IconPinSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m18.966 2.622 2.55 2.543c.646.644.646 1.69 0 2.334l-5.692 5.676.142.255c1.076 1.933.872 4.477-.695 6.04l-2.23 2.225-4.294-4.283L2.716 22 2 21.286l4.6-6.016-4.294-4.282 2.23-2.225c1.568-1.563 4.111-1.792 6.049-.718l.255.141L16.53 2.51c.646-.645 1.569-.752 2.435.112Z" />
  </svg>
);
export default IconPinSizeM;
